import { useState } from 'react';
import { Share2 } from 'lucide-react';
import KnowledgeGraph from '../components/KnowledgeGraph';
import RecordDetailModal from '../components/RecordDetailModal';

// The record as a graph: start from any record and expand outwards through its
// relationships. Opening a node shows its detail, as it does on Records.
export default function GraphPage() {
    const [target, setTarget] = useState<{ label: string; key: string } | null>(null);
    // A merge or split changes which nodes exist, so the graph starts again.
    const [version, setVersion] = useState(0);

    return (
        <div>
            <div className="pb-6 mb-6 border-b border-softgrey">
                <h3 className="text-lg font-semibold flex items-center gap-2">
                    <Share2 className="w-5 h-5 text-brand" /> Graph
                </h3>
                <p className="text-sm text-coolslate mt-1">
                    Pick a record to start from and expand through its relationships. Open any node to see what is known about it.
                </p>
            </div>

            <KnowledgeGraph key={version} onOpenNode={(label, key) => setTarget({ label, key })} />

            {target && (
                <RecordDetailModal
                    target={target}
                    onNavigate={(label, key) => setTarget({ label, key })}
                    onClose={() => setTarget(null)}
                    onChanged={() => setVersion(v => v + 1)}
                />
            )}
        </div>
    );
}
